const environment = {
  baseUrl: "http://localhost:3008/", //"http://localhost:3000",
  api: "http://localhost:8080/", //"http://localhost:8080/api",
};

if (process.env.REACT_APP_ENV === "development") {
  environment.baseUrl = "http://localhost:3008/";
  environment.api = "http://localhost:8080/";
}

if (process.env.REACT_APP_ENV === "staging") {
  environment.baseUrl = "https://staging.big.go.id/";
  environment.api = "https://staging.big.go.id/api-inageo/";
}

if (process.env.REACT_APP_ENV === "production") {
  environment.baseUrl = "https://tanahair.indonesia.go.id/v3/";
  environment.api = "https://tanahair.indonesia.go.id/api-inageo/";
}

export default environment;
